import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X, Phone, Facebook, Youtube, Twitter, Instagram } from 'lucide-react';
import { LOGO_URL } from '../data/cities';

// ------- Inline brand icons lucide does not cover -------
function HouzzIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16 0v8H8V0H2v24h6v-8h8v8h6V0z" />
    </svg>
  );
}
function PinterestIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.427 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345c-.091.379-.293 1.193-.333 1.36-.053.22-.174.267-.402.161-1.499-.698-2.436-2.888-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.608 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0" />
    </svg>
  );
}

// ------- Floating left social rail (matches american-pools.com) -------
export const SocialRail = () => {
  const items = [
    { Icon: Facebook, label: 'Facebook', href: 'https://www.facebook.com/AmericanPoolsSpas', color: '#1877F2' },
    { Icon: Youtube, label: 'YouTube', href: 'https://www.youtube.com/channel/UC29-XIIPCYvfEz-ZJvhlcag', color: '#FF0000' },
    { Icon: Twitter, label: 'Twitter', href: 'https://twitter.com/AmPoolsSpas', color: '#111111' },
    { Icon: HouzzIcon, label: 'Houzz', href: 'https://www.houzz.com/pro/americanpoolsspas/__public', color: '#4DBC15' },
    { Icon: PinterestIcon, label: 'Pinterest', href: 'https://www.pinterest.com/Am_Pools_Spas/', color: '#E60023' },
    { Icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/americanpoolsspas/', color: '#E4405F' },
  ];
  return (
    <div className="hidden xl:flex fixed left-0 top-1/2 -translate-y-1/2 z-40 flex-col shadow-lg">
      {items.map(({ Icon, label, href, color }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          className="w-10 h-10 flex items-center justify-center text-white transition-all duration-200 hover:w-12"
          style={{ backgroundColor: color }}
        >
          <Icon className="w-[18px] h-[18px]" />
        </a>
      ))}
    </div>
  );
};

const navItems = [
  {
    label: 'POOLS',
    href: 'https://american-pools.com/pool-builder-orlando/',
    sub: [
      { label: 'Why Choose Us', href: 'https://american-pools.com/pool-builder-orlando/why-choose-us/' },
      { label: 'Pool Design Process', href: 'https://american-pools.com/pool-builder-orlando/pool-design-process/' },
      { label: 'Pool Renovation', href: 'https://american-pools.com/pool-builder-orlando/pool-renovation/' },
      { label: 'Commercial Pools', href: 'https://american-pools.com/orlando-pool-galleries/commercial-pools/' },
    ],
  },
  {
    label: 'OUTDOOR LIVING',
    href: 'https://american-pools.com/orlando-pool-products-features/',
    sub: [
      { label: 'Outdoor Kitchens', href: 'https://american-pools.com/orlando-pool-products-features/outdoor-kitchens/' },
      { label: 'Screen Enclosures', href: 'https://american-pools.com/orlando-pool-products-features/screen-enclosures/' },
      { label: 'Pool Deck Pavers', href: 'https://american-pools.com/orlando-pool-products-features/pool-deck-pavers/' },
      { label: 'Pool Equipment', href: 'https://american-pools.com/orlando-pool-products-features/pool-equipment/' },
    ],
  },
  {
    label: 'GALLERIES',
    href: 'https://american-pools.com/orlando-pool-galleries/',
    sub: [
      { label: 'Swimming Pools', href: 'https://american-pools.com/orlando-pool-galleries/swimming-pools/' },
      { label: 'Spas', href: 'https://american-pools.com/orlando-pool-galleries/spas/' },
      { label: 'Water Features', href: 'https://american-pools.com/orlando-pool-galleries/water-features/' },
      { label: 'Fire Features', href: 'https://american-pools.com/orlando-pool-galleries/fire-features/' },
      { label: 'Pergolas', href: 'https://american-pools.com/orlando-pool-galleries/pergolas/' },
      { label: 'Decks', href: 'https://american-pools.com/orlando-pool-galleries/decks/' },
      { label: 'Outdoor Kitchens', href: 'https://american-pools.com/orlando-pool-galleries/outdoor-kitchens/' },
      { label: 'Screen Enclosures', href: 'https://american-pools.com/orlando-pool-galleries/screen-enclosures/' },
      { label: 'Featured Pools', href: 'https://american-pools.com/orlando-pool-galleries/featured-pools/' },
    ],
  },
  { label: 'CUSTOMER PORTAL', href: 'https://american-pools.com/customer-portal/' },
  { label: 'FINANCING', href: 'https://american-pools.com/financing/' },
  {
    label: 'ABOUT',
    href: 'https://american-pools.com/about-us/',
    sub: [
      { label: 'Our Company', href: 'https://american-pools.com/about-us/' },
      { label: 'Pool Builder Reviews', href: 'https://american-pools.com/about-us/pool-builder-reviews/' },
      { label: 'Service Area', href: 'https://american-pools.com/about-us/service-area/' },
      { label: 'Pool Blog', href: 'https://american-pools.com/blog/' },
    ],
  },
  { label: 'CONTACT', href: 'https://american-pools.com/contact-us/' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  return (
    <header className="w-full sticky top-0 z-50 bg-white shadow-sm">
      <div className="border-b border-gray-200">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between px-4 lg:px-6 py-2">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 py-1">
            <img
              src={LOGO_URL}
              alt="American Pools & Spas - A Cody Pools Company"
              className="h-[70px] w-auto object-contain"
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1 xl:gap-2">
            {navItems.map((item) => (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() => setOpenMenu(item.label)}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <a
                  href={item.href}
                  className="flex items-center gap-1 px-3 xl:px-4 py-6 text-[13px] xl:text-[14px] font-semibold text-[#0b1e4d] tracking-wide hover:text-[#1e4fa3] transition-colors"
                >
                  {item.label}
                  {item.sub && <ChevronDown className="w-3 h-3" />}
                </a>
                {item.sub && openMenu === item.label && (
                  <div className="absolute top-full left-0 min-w-[240px] bg-white shadow-xl border border-gray-100 py-2 z-50">
                    {item.sub.map((s) => (
                      <a
                        key={s.label}
                        href={s.href}
                        className="block px-5 py-2 text-[13px] text-[#0b1e4d] hover:bg-[#f3f6fb] hover:text-[#1e4fa3] transition-colors"
                      >
                        {s.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Call CTA */}
          <a
            href="tel:4076066375"
            className="hidden md:flex flex-col items-center bg-[#1e4fa3] text-white px-4 py-2 rounded-sm hover:bg-[#183d80] transition-colors"
          >
            <span className="text-[11px] font-semibold uppercase leading-tight">
              Click or Call For A Free Estimate
            </span>
            <span className="flex items-center gap-1 text-[18px] font-bold leading-tight mt-0.5">
              <Phone className="w-4 h-4" /> 407-606-6375
            </span>
          </a>

          <button
            className="lg:hidden p-2 text-[#0b1e4d]"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 max-h-[70vh] overflow-y-auto">
          {navItems.map((item) => (
            <div key={item.label} className="border-b border-gray-100">
              <a
                href={item.href}
                className="block px-5 py-3 text-sm font-semibold text-[#0b1e4d]"
              >
                {item.label}
              </a>
              {item.sub && (
                <div className="bg-gray-50 py-1">
                  {item.sub.map((s) => (
                    <a
                      key={s.label}
                      href={s.href}
                      className="block px-8 py-2 text-[13px] text-gray-700"
                    >
                      {s.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
          <a
            href="tel:4076066375"
            className="block bg-[#1e4fa3] text-white text-center py-3 font-bold"
          >
            Call For Free Estimate: 407-606-6375
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
